import React from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { EmptyState, CodeSnippet } from '@backstage/core-components';

const EXAMPLE = `auth:
  providers:
    google:
      development:
        clientId: \${AUTH_GOOGLE_CLIENT_ID}
        clientSecret: \${AUTH_GOOGLE_CLIENT_SECRET}
`;
const EmptyProviders = () => /* @__PURE__ */ React.createElement(
  EmptyState,
  {
    missing: "content",
    title: "No Authentication Providers",
    description: "You can add Authentication Providers to Backstage which allows you to use these providers to authenticate yourself.",
    action: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Typography, { variant: "body1" }, "Open ", /* @__PURE__ */ React.createElement("code", null, "app-config.yaml"), " and make the changes as highlighted below:"), /* @__PURE__ */ React.createElement(
      CodeSnippet,
      {
        text: EXAMPLE,
        language: "yaml",
        showLineNumbers: true,
        highlightedNumbers: [3, 4, 5, 6, 7, 8],
        customStyle: { background: "inherit", fontSize: "115%" }
      }
    ), /* @__PURE__ */ React.createElement(
      Button,
      {
        variant: "contained",
        color: "primary",
        href: "https://backstage.io/docs/auth/add-auth-provider"
      },
      "Read More"
    ))
  }
);

export { EmptyProviders };
//# sourceMappingURL=EmptyProviders.esm.js.map
